// PrivateRoute.tsx
import React, { ReactNode, FC } from 'react';
import { Navigate } from 'react-router-dom';
import {getToken} from "../auth/service/authService";


interface ContainerProps {
    children?: ReactNode;
}

const PrivateRoute: FC<ContainerProps> = ({ children }) => {
    const authenticated = getToken();
    return authenticated ? <>{children}</> : <Navigate to="/login" />;
};

export default PrivateRoute;